import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=a49ea610&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a49ea610')) {
      api.createRecord('a49ea610', component.options)
    } else {
      api.reload('a49ea610', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=a49ea610&", function () {
      api.rerender('a49ea610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Hy3XL3PKK4Vk/JS/ImageCarousel.vue"
export default component.exports